import { Component, Input } from '@angular/core';
export type TS_BADGE_TYPES = 'success' | 'warning' | 'error' | 'info' | 'transparent' | 'gray' | 'avatar';

@Component({
  selector: 'ts-badge',
  templateUrl: './ts-badge.component.html',
  styleUrls: ['./ts-badge.component.scss'],
})
export class TsBadgeComponent {
  @Input() value: string;
  @Input() type: TS_BADGE_TYPES = 'warning';
  @Input() floating = false;
  @Input() showSpinner = false;
  @Input() noOverlap = false;
}
